export const FONTS = Object.freeze({
  regular: 400,
  medium: 500,
  bold: 700,
  black: 900,
});
